export const EhouseDoubleCalculatingTypes = {
  C1: "C1",
  C2: "C2",
  C3: "C3",
};

export const EhouseDoubleCalculatingTypeList = Object.values(
  EhouseDoubleCalculatingTypes
).map((type) => ({
  label: type,
  value: type,
}));
